'use client';

import React, { HTMLAttributes, ReactNode } from 'react';

interface FormLabelProps extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  sub?: string;
  isIndentedSub?: boolean;
}

/**
 * 共通ラベル
 * @param param0
 * @returns
 */
const FormLabel: React.FC<FormLabelProps> = ({ children, sub, className, isIndentedSub, ...headingProps }) => {
  return (
    <h4
      className={`text-lg py-1 mb-1 font-footballlog font-bold text-gray-500 dark:text-white ${className}`}
      {...headingProps}>
      {children}
      {isIndentedSub && <br />}
      {sub && <span className="text-xs inline">{sub}</span>}
    </h4>
  );
};

export default FormLabel;
